import { isElectron } from "app/utils/system";

export const isWeb = !isElectron();

export const path = isWeb ? {} : window.require('path');
